/**
 *
 * @param {*} data
 * @param {*} crs
 */
export function loopData(data, crs) {
    if (data.type === "FeatureCollection") {
        data = loopFeatureCollection(data);
    } else if (data.type === "Point") {
        data = oopPoint(data);
    } else if (data.type === "LineString" || data.type === "MultiPoint") {
        data = loopLine(data);
    } else if (data.type === "Polygon" || data.type === "MultiLineString") {
        data = loopPolygon(data);
    } else if (data.type === "MultiPolygon") {
        data = loopMultiPolygon(data);
    }
    console.log("loopdata", data);
    return data;
}

/**
 * 原先的 90 ~ -90  -> 90 ~ -270， 按照对应的百分比处理
 * @param {*} lat
 */
function fixLat(lat) {
    let percent = (90 + lat) / 180;
    let zero = 90 * percent;
    return zero || 45 + zero / 2;
}

function loopFeatureCollection(data) {
    data.features = data.features.map((f) => {
        if (f.geometry.type === "Point") {
            f = loopPoint(f);
        } else if (
            f.geometry.type === "LineString" ||
            data.type === "MultiPoint"
        ) {
            f = loopLine(f);
        } else if (
            f.geometry.type === "Polygon" ||
            data.type === "MultiLineString"
        ) {
            f = loopPolygon(f);
        } else if (f.geometry.type === "MultiPolygon") {
            f = loopMultiPolygon(f);
        }
        return f;
    });
    return data;
}

// "coordinates": [102,0.5]
function loopPoint(feature) {
    feature.geometry.coordinates[1] = fixLat(feature.geometry.coordinates[1]);
    return feature;
}

// "coordinates": [[102, 0], [103, 1], [104, 0],[105, 1]]
function loopLine(feature) {
    feature.geometry.coordinates = feature.geometry.coordinates.map((p) => {
        p[1] = fixLat(p[1]);
        return p;
    });
    return feature;
}

function loopPolygon(feature) {
    feature.geometry.coordinates = feature.geometry.coordinates.map((r) => {
        r = r.map((p) => {
            p[1] = fixLat(p[1]);
            return p;
        });
        return r;
    });
    return feature;
}

function loopMultiPolygon(feature) {
    feature.geometry.coordinates = feature.geometry.coordinates.map((m) => {
        m.map((r) => {
            r = r.map((p) => {
                p[1] = fixLat(p[1]);
                return p;
            });
            return r;
        });
        return m;
    });
    return feature;
}
